import { Link } from 'react-router-dom';

import style from './NotebookPageHeaderStudentView.scss';

const NotebookPageHeaderStudentView = ({
  lessonTitle,
  classCode,
  previousLessonLink,
  nextLessonLink,
}: NotebookPageHeaderStudentViewProps): JSX.Element => {
  const previousLessonLinkText = '<< Previous lesson';
  const nextLessonLinkText = 'Next lesson >>';

  return (
    <>
      <div className={style.headerContainer}>
        <div>
          <h1 className={style.lessonTitle}>{lessonTitle}</h1>
          <span className={style.classCode}>{classCode}</span>
        </div>
        <div>
          {previousLessonLink ? (
            <Link to={previousLessonLink} className={style.previousLessonLink}>
              {previousLessonLinkText}
            </Link>
          ) : (
            <span className={style.disabledLink}>{previousLessonLinkText}</span>
          )}
          <span className={style.spacer}>|</span>
          {nextLessonLink ? (
            <Link to={nextLessonLink} className={style.nextLessonLink}>
              {nextLessonLinkText}
            </Link>
          ) : (
            <span className={style.disabledLink}>{nextLessonLinkText}</span>
          )}
        </div>
      </div>
      <div className={style.divider} />
    </>
  );
};

export default NotebookPageHeaderStudentView;

interface NotebookPageHeaderStudentViewProps {
  lessonTitle: string;
  classCode: string;
  previousLessonLink: string;
  nextLessonLink: string;
}
